import React, { useState } from "react";
import pic1 from "../../images/pic1.png";
import LoginForm from "./LoginForm";
import Footer from "../../common/Footer/Footer"

const style = {
  background: `url(${pic1}), lightgray 50%`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  height: "100.9vh",
  marginTop: -50,
  padding: 10,
};
function LoginPage() {
  

  return (
    <>
    <div style={style} >
      <LoginForm />
      
    </div>
    <Footer />
    </>
  );
}

export default LoginPage;
